import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";

export default function PaginationControlButton({
  tooltipProps,
  ...rest
}: TooltipIconButtonProps) {
  return (
    <TooltipIconButton
      {...rest}
      tooltipProps={{ openDelay: 500, placement: "bottom", ...tooltipProps }}
    />
  );
}
